import { forwardRef } from 'react';
import { createGenericContext, createBemBlockBuilder } from '@ebsco-ui/utils';
import cn from 'classnames';
import { jsx } from 'react/jsx-runtime';

var _createGenericContext = createGenericContext({
  errorMessage: "Card compound components cannot be rendered outside the Card component"
}),
    useCardContext = _createGenericContext.useGenericContext;
    _createGenericContext.GenericContextConsumer;
    var CardContextProvider = _createGenericContext.GenericContextProvider;

var CardHeader = function CardHeader(_ref) {
  var children = _ref.children;

  var _useCardContext = useCardContext(),
      getBemBlocksWith = _useCardContext.getBemBlocksWith;

  return /*#__PURE__*/jsx("div", {
    className: cn(getBemBlocksWith("__header")),
    "data-auto": "card-header",
    children: children
  });
};

var CardFooter = function CardFooter(_ref) {
  var children = _ref.children;

  var _useCardContext = useCardContext(),
      getBemBlocksWith = _useCardContext.getBemBlocksWith;

  return /*#__PURE__*/jsx("div", {
    className: cn(getBemBlocksWith("__footer")),
    "data-auto": "card-footer",
    children: children
  });
};

var Card = forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _ref$isRounded = _ref.isRounded,
      isRounded = _ref$isRounded === void 0 ? false : _ref$isRounded,
      _ref$isTransparent = _ref.isTransparent,
      isTransparent = _ref$isTransparent === void 0 ? true : _ref$isTransparent,
      _ref$isRaised = _ref.isRaised,
      isRaised = _ref$isRaised === void 0 ? false : _ref$isRaised,
      _ref$isHoverable = _ref.isHoverable,
      isHoverable = _ref$isHoverable === void 0 ? false : _ref$isHoverable,
      ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      id = _ref.id,
      border = _ref.border;
  var getBemBlocksWith = createBemBlockBuilder(["eb-card", className]);
  var classNames = cn(getBemBlocksWith(), border === "all" && getBemBlocksWith("--border"), border && border !== "all" && getBemBlocksWith("--border-".concat(border)), isHoverable && getBemBlocksWith("--hoverable"), isRounded && border === "all" && getBemBlocksWith("--rounded"), isRaised && getBemBlocksWith("--raised"), isTransparent && getBemBlocksWith("--transparent"));
  var cardContext = {
    getBemBlocksWith: getBemBlocksWith
  };
  return /*#__PURE__*/jsx(CardContextProvider, {
    value: cardContext,
    children: /*#__PURE__*/jsx("section", {
      ref: ref,
      id: id,
      className: classNames,
      "aria-label": ariaLabel,
      "data-auto": "card",
      children: children
    })
  });
});
Card.Header = CardHeader;
Card.Header.displayName = "Card.Header";
Card.Footer = CardFooter;
Card.Footer.displayName = "Card.Footer";
Card.displayName = "Card";

export { Card as default };
//# sourceMappingURL=card-esm.js.map
